import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAPI } from "../Context/MyContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../assets/svg.png";
import FacebookLogin from "./FacebookLogin";
import { FaFacebookF, FaEye, FaEyeSlash, FaArrowLeft } from "react-icons/fa";
import { Helmet } from 'react-helmet-async';
import chatFavicon from "../assets/favicon/favicon.ico";

const Login = () => {
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  // const { loginUser } = useContext(MyContext);
  const navigate = useNavigate();
  const { loginUser, ForgotPassword, VerifyOtp, ResetPassword, Login, user, LoginTwoFactorVerify } = useAPI();

  // Forgot password states
  const [step, setStep] = useState("email");
  // const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [loginLoading, setLoginLoading] = useState(false);

  // const [showOtpDialog, setShowOtpDialog] = useState(false);

  const [showForgotOtpDialog, setShowForgotOtpDialog] = useState(false);
  const [show2FADialog, setShow2FADialog] = useState(false);


  // Separate OTP values (important)
  const [forgotOtp, setForgotOtp] = useState(["", "", "", "", "", ""]);
  const [loginOtp, setLoginOtp] = useState(["", "", "", "", "", ""]);

  const forgotOtpRefs = useRef([]);
  const loginOtpRefs = useRef([]);

  // ---------------- LOGIN HANDLER -----------------
  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) setEmailError("Please enter a valid email address.");
    else setEmailError("");
  };

  useEffect(() => {
    if (user?.token) {
      navigate("/dashboard");
    }
  }, [user]);




  // const handleLogin = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const response = await Login({ email, password });

  //     console.log("response login::", response);

  //     // 2FA required
  //     if (response.success && response.twoFactorRequired) {
  //       toast.success(`Verification code sent via ${response.method}`);
  //       setShow2FADialog(true);   // open OTP modal
  //       return; // stop normal login flow
  //     }

  //     // Normal login (no 2FA)
  //     if (response.success) {
  //       toast.success("Login successful!");
  //       loginUser(response.data);
  //       setTimeout(() => navigate("/dashboard"), 800);
  //     } else {
  //       toast.error(response.message || "Invalid email or password.");
  //     }

  //   } catch (error) {
  //     console.log("Login error:", error);
  //     toast.error(
  //       error.response?.data?.message ||
  //       error.message ||
  //       "Something went wrong. Please try again."
  //     );
  //   }
  // };


  const handleLogin = async (e) => {
    e.preventDefault();

    setLoginLoading(true);

    try {
      const response = await Login({ email, password });

      console.log("response login::", response.data);

      if (response.success && response.data?.code === "ACCOUNT_INACTIVE") {

        setTimeout(() => navigate("/inactive"), 800);

        setLoginLoading(false);
        return;
      }

      if (response.success && response.data?.code === "PLAN_EXPIRED") {

        setTimeout(() => navigate("subscription-expired"), 800);

        setLoginLoading(false);
        return;
      }






      if (response.success && response.twoFactorRequired) {
        toast.success(`Verification code sent via ${response.method}`);
        setShow2FADialog(true);
        setLoginLoading(false);
        return;
      }

      if (response.success) {
        toast.success("Login successful!");
        loginUser(response.data);
        setTimeout(() => navigate("/dashboard"), 800);
      } else {
        toast.error(response.message || "Invalid email or password.");
      }

    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong."
      );
    }

    setLoginLoading(false);
  };


  const handleLogin2FA = async () => {
    // const otpString = otp.join("");
    const otpString = loginOtp.join("");

    if (otpString.length !== 6) {
      return toast.error("Please enter the full verification code");
    }

    setIsLoading(true);

    try {
      const response = await LoginTwoFactorVerify({
        email,
        otp: otpString,
      });

      if (response.success) {
        toast.success("Login successful!");
        loginUser(response.data);

        // setShowOtpDialog(false);
        // setOtp(["", "", "", "", "", ""]);
        setShow2FADialog(false);
        setLoginOtp(["", "", "", "", "", ""]);

        setTimeout(() => navigate("/dashboard"), 800);
      } else {
        toast.error(response.message || "Invalid code");
      }

    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        "Verification failed"
      );
    }

    setIsLoading(false);
  };

  // ---------------- FORGOT PASSWORD HANDLERS -----------------
  const handleSendOtp = async (e) => {
    e.preventDefault();

    // console.log("Forgot Password Step:", { email })

    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      toast.error("Please enter a valid email");
      return;
    }
    setIsLoading(true);


    try {
      const response = await ForgotPassword({ email });
      if (response.success) {
        toast.success("OTP sent to your email!");
        await new Promise((r) => setTimeout(r, 1000));
        // setShowOtpDialog(true);

        setShowForgotOtpDialog(true);
        setStep("otp");
        setIsLoading(false);
      } else {
        toast.error(response.message);
        setIsLoading(false);
      }
    } catch {
      toast.error("Something went wrong.");
      setIsLoading(false);
    }


  };

  // const handleOtpChange = (index, value) => {
  //   if (value.length > 1) return;
  //   const newOtp = [...otp];
  //   newOtp[index] = value;
  //   setOtp(newOtp);
  //   if (value && index < 5) document.getElementById(`otp-${index + 1}`)?.focus();
  // };


  // const handleOtpChange = (index, value, type) => {
  //   if (value.length > 1) return;

  //   if (type === "forgot") {
  //     const newOtp = [...forgotOtp];
  //     newOtp[index] = value;
  //     setForgotOtp(newOtp);
  //   } else {
  //     const newOtp = [...loginOtp];
  //     newOtp[index] = value;
  //     setLoginOtp(newOtp);
  //   }
  // };

  const handleOtpChange = (index, value, type) => {
    if (!/^[0-9]?$/.test(value)) return; // only digits

    if (type === "forgot") {
      const newOtp = [...forgotOtp];
      newOtp[index] = value;
      setForgotOtp(newOtp);

      // move forward
      if (value && index < 5) {
        forgotOtpRefs.current[index + 1]?.focus();
      }
    } else {
      const newOtp = [...loginOtp];
      newOtp[index] = value;
      setLoginOtp(newOtp);

      if (value && index < 5) {
        loginOtpRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleOtpKeyDown = (index, e, type) => {
    if (e.key === "Backspace") {
      if (type === "forgot") {
        if (!forgotOtp[index] && index > 0) {
          forgotOtpRefs.current[index - 1]?.focus();
        }
      } else {
        if (!loginOtp[index] && index > 0) {
          loginOtpRefs.current[index - 1]?.focus();
        }
      }
    }
  };


  const handleOtpPaste = (e, type) => {
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasteData) return;

    const otpArray = pasteData.split("");

    if (type === "forgot") {
      setForgotOtp([...otpArray, ...Array(6 - otpArray.length).fill("")]);
      forgotOtpRefs.current[otpArray.length - 1]?.focus();
    } else {
      setLoginOtp([...otpArray, ...Array(6 - otpArray.length).fill("")]);
      loginOtpRefs.current[otpArray.length - 1]?.focus();
    }
  };

  const handleVerifyOtp = async () => {
    const otpString = forgotOtp.join("");

    // console.log("Verify OTP", { otp: otpString, email });

    if (otpString.length !== 6) {
      toast.error("Please enter the full OTP");
      return;
    }
    setIsLoading(true);
    // await new Promise((r) => setTimeout(r, 1000));
    // toast.success("OTP verified! Set your new password.");
    // setShowOtpDialog(false);
    // setStep("reset");
    // setIsLoading(false);

    try {
      const response = await VerifyOtp({ email, otp: otpString, });
      if (response.success) {
        toast.success("OTP verified! Set your new password.");
        // setShowOtpDialog(false);

        setShowForgotOtpDialog(false);
        setForgotOtp(["", "", "", "", "", ""]);

        setStep("reset");
        setIsLoading(false);
      } else {
        toast.error(response.message);
        setIsLoading(false);
      }
    } catch {
      toast.error("Invalid OTP or server error.");
      setIsLoading(false);
    }


  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    // console.log("Reset Password", {
    //   email,
    //   newPassword,
    //   confirmPassword,
    // });

    if (newPassword.length < 8)
      return toast.error("Password must be at least 8 characters");
    if (newPassword !== confirmPassword)
      return toast.error("Passwords do not match");

    setIsLoading(true);

    try {
      const response = await ResetPassword({ email, newPassword });
      if (response.success) {
        toast.success("Password reset successfully!");
        setTimeout(() => {
          setShowForgotPassword(false);
          setStep("email");
          // Clear all data for fresh start
          setEmail("");
          // setOtp(["", "", "", "", "", ""]);
          setNewPassword("");
          setConfirmPassword("");
          setShowNewPassword(false);
          setShowConfirmPassword(false);

        }, 600);
        setIsLoading(false);
        setTimeout(() => navigate("/#"), 1000);
      } else {
        toast.error(response.message);
        setIsLoading(false);
      }
    } catch {
      toast.error("Failed to reset password.");
      setIsLoading(false);
    }



  };




  const handleResendOtp = async () => {
    console.log("Resend OTP", { email });
    toast.success("OTP resent successfully!");
    // setOtp(["", "", "", "", "", ""]);
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setStep("email");
    // setOtp(["", "", "", "", "", ""]);
    setNewPassword("");
    setConfirmPassword("");
  };

  // ---------------- MAIN UI -----------------
  return (
    <>
      <Helmet>
        <title>Dashboard | WhatGrowPro</title>
        <meta
          name="description"
          content="Manage real-time customer conversations using WhatGrowPro’s Live Chat — connect instantly and improve customer satisfaction."
        />
        <meta name="keywords" content="Live Chat, WhatsApp automation, customer support, WhatGrowPro" />
        <link rel="icon" type="image/png" href={chatFavicon} />
      </Helmet>


      <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-green-50 flex items-center justify-center p-4">
        <ToastContainer position="top-right" autoClose={3000} />

        <div className="w-full max-w-6xl grid lg:grid-cols-2 gap-8 items-center">
          {/* LEFT SIDE */}
          <div className="hidden lg:flex flex-col justify-center space-y-6 px-8">
            <div className="flex items-center space-x-3">
              <img
                src={logo}
                alt="WhatGrowPro Logo"
                className="w-14 h-14 sm:w-16 sm:h-16 md:w-18 md:h-18 lg:w-20 lg:h-20 object-contain -mr-4"
              />
              <div>
                <h1 className="text-xl sm:text-2xl lg:text-2xl font-bold text-gray-800">WhatGrowPro</h1>
                <p className="text-xs sm:text-sm text-gray-500">Grow smarter, market faster</p>
              </div>
            </div>

            <h2 className="text-4xl font-bold text-gray-800 leading-tight">
              Welcome Back to Your Marketing Hub
            </h2>

            <p className="text-gray-600 text-lg">
              Access your dashboard and continue growing your business with powerful WhatsApp marketing tools.
            </p>

            <div className="space-y-4 pt-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">Real-Time Analytics</h3>
                  <p className="text-sm text-gray-600">Monitor campaign performance instantly</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">Lightning Fast Delivery</h3>
                  <p className="text-sm text-gray-600">Send messages to thousands in seconds</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">Secure & Compliant</h3>
                  <p className="text-sm text-gray-600">Enterprise-grade security standards</p>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-10 relative overflow-hidden">
            {!showForgotPassword ? (
              <div key="login" className="animate-slide-in">
                <div className="mb-8">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    Welcome Back
                  </h3>
                  <p className="text-gray-600">Sign in to access your dashboard</p>
                </div>

                {/* LOGIN FORM */}
                <form onSubmit={handleLogin} className="space-y-5">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        validateEmail(e.target.value);
                      }}
                      required
                      className={`w-full px-4 py-3 border ${emailError
                        ? "border-red-500 focus:ring-red-500"
                        : "border-gray-300 focus:ring-green-500"
                        } rounded-lg focus:ring-2 focus:border-transparent outline-none transition-all-smooth`}
                      placeholder="Enter your email"
                    />
                    {emailError && (
                      <p className="text-red-500 text-sm mt-1 animate-fade-in">{emailError}</p>
                    )}
                  </div>

                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 pr-10 transition-all-smooth"
                      placeholder="••••••••"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-11 text-gray-500 hover:text-green-600 transition-colors"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                        className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                      />
                      <label className="ml-2 text-sm text-gray-700">
                        Remember me
                      </label>
                    </div>

                    <button
                      type="button"
                      onClick={() => setShowForgotPassword(true)}
                      className="text-green-600 hover:text-green-700 font-medium text-sm transition-colors"
                    >
                      Forgot password?
                    </button>
                  </div>

                  {/* <button
                    type="submit"
                    className="w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-3.5 px-4 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                  >
                    Sign In
                  </button> */}
                  <button
                    type="submit"
                    disabled={loginLoading}
                    className="w-full bg-green-500 hover:bg-green-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-semibold py-3.5 px-4 rounded-lg transition-all duration-200 shadow-lg flex items-center justify-center gap-2"
                  >
                    {loginLoading ? (
                      <>
                        <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                        Signing in...
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </button>


                  <div className="relative my-6">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t border-gray-300"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="px-4 bg-white text-gray-500">Or</span>
                    </div>
                  </div>

                  <FacebookLogin />

                  <div className="text-center">
                    <p className="text-gray-600">
                      Don't have an account?{" "}
                      <Link
                        to="/whatapp/register"
                        className="text-green-600 font-semibold hover:text-green-700 transition-colors"
                      >
                        Register here
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            ) : (
              <div key="forgot" className="animate-slide-left">
                {/* FORGOT PASSWORD UI */}
                <button
                  onClick={handleBackToLogin}
                  className="flex items-center text-sm text-gray-500 hover:text-green-600 mb-6 transition-colors group"
                >
                  <FaArrowLeft className="mr-2 group-hover:-translate-x-1 transition-transform" /> Back to Login
                </button>

                <div className="mb-8">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    {step === "email" && "Reset Password"}
                    {step === "reset" && "Create New Password"}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {step === "email" && "Enter your registered email to receive a verification code"}
                    {step === "reset" && "Choose a strong password for your account"}
                  </p>
                </div>

                {step === "email" && (
                  <form onSubmit={handleSendOtp} className="space-y-5 animate-fade-in">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Email Address
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 transition-all-smooth"
                        placeholder="you@example.com"
                      />
                    </div>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="w-full bg-green-500 hover:bg-green-600 disabled:bg-gray-400 text-white font-semibold py-3 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                    >
                      {isLoading ? "Sending..." : "Send Reset Code"}
                    </button>
                  </form>
                )}

                {step === "reset" && (
                  <form onSubmit={handleResetPassword} className="space-y-5 animate-fade-in">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        New Password
                      </label>
                      <div className="relative">
                        <input
                          type={showNewPassword ? "text" : "password"}
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg pr-10 focus:ring-2 focus:ring-green-500 transition-all-smooth"
                          placeholder="••••••••"
                          required
                        />
                        <button
                          type="button"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          className="absolute right-3 top-4 text-gray-500 hover:text-green-600 transition-colors"
                        >
                          {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                      <p className="text-xs text-gray-500 mt-1">Must be at least 8 characters</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Confirm Password
                      </label>
                      <div className="relative">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg pr-10 focus:ring-2 focus:ring-green-500 transition-all-smooth"
                          placeholder="••••••••"
                          required
                        />
                        <button
                          type="button"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          className="absolute right-3 top-4 text-gray-500 hover:text-green-600 transition-colors"
                        >
                          {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                    </div>

                    <button
                      type="submit"
                      disabled={isLoading}
                      className="w-full bg-green-500 hover:bg-green-600 disabled:bg-gray-400 text-white font-semibold py-3 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                    >
                      {isLoading ? "Resetting..." : "Reset Password"}
                    </button>
                  </form>
                )}
              </div>
            )}

            {/* OTP DIALOG */}
            {/* {showOtpDialog && ( */}
            {/* {showForgotOtpDialog && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm animate-fade-in">
                <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-4 animate-slide-in">
                  <h2 className="text-2xl font-bold mb-2 text-gray-800">
                    Enter Verification Code
                  </h2>
                  <p className="text-sm text-gray-500 mb-6">
                    We've sent a 6-digit code to <span className="font-semibold text-gray-700">{email}</span>
                  </p>

                  <div className="flex justify-center space-x-2 mb-6">
                    {otp.map((digit, i) => (
                      <input
                        key={i}
                        id={`otp-${i}`}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(i, e.target.value)}
                        className="w-12 h-12 border-2 border-gray-300 text-center text-lg font-semibold rounded-lg focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all-smooth"
                      />
                    ))}
                  </div>

                  <button
                    onClick={handleVerifyOtp}
         
                    disabled={isLoading}
                    className="w-full bg-green-500 hover:bg-green-600 disabled:bg-gray-400 text-white font-semibold py-3 rounded-lg mb-3 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                  >
                    {isLoading ? "Verifying..." : "Verify Code"}
                  </button>
              
                </div>
              </div>
            )} */}

            {/* Forgot Password OTP Dialog */}
            {showForgotOtpDialog && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
                <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-4">
                  <h2 className="text-2xl font-bold mb-2 text-gray-800">
                    Reset Password Verification
                  </h2>
                  <p className="text-sm text-gray-500 mb-6">
                    Enter the code sent to <b>{email}</b>
                  </p>

                  <div className="flex justify-center space-x-2 mb-6">
                    {/* {forgotOtp.map((digit, i) => (
                      <input
                        key={i}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(i, e.target.value, "forgot")}
                        className="w-12 h-12 border-2 border-gray-300 text-center rounded-lg"
                      />
                    ))} */}
                    {forgotOtp.map((digit, i) => (
                      <input
                        key={i}
                        ref={(el) => (forgotOtpRefs.current[i] = el)}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(i, e.target.value, "forgot")}
                        onKeyDown={(e) => handleOtpKeyDown(i, e, "forgot")}
                        onPaste={(e) => handleOtpPaste(e, "forgot")}
                        className="w-12 h-12 border-2 border-gray-300 text-center rounded-lg"
                      />
                    ))}
                  </div>

                  <button
                    onClick={handleVerifyOtp}
                    disabled={isLoading}
                    className="w-full bg-green-500 text-white py-3 rounded-lg"
                  >
                    {isLoading ? "Verifying..." : "Verify Code"}
                  </button>
                </div>
              </div>
            )}


            {/* 2fa OTP DIALOG */}
            {/* {showOtpDialog && ( */}
            {/* Login 2FA Dialog */}
            {show2FADialog && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
                <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-4">
                  <h2 className="text-2xl font-bold mb-2 text-gray-800">
                    Two-Factor Authentication
                  </h2>
                  <p className="text-sm text-gray-500 mb-6">
                    Enter the verification code sent to <b>{email}</b>
                  </p>

                  <div className="flex justify-center space-x-2 mb-6">
                    {/* {loginOtp.map((digit, i) => (
                      <input
                        key={i}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(i, e.target.value, "login")}
                        className="w-12 h-12 border-2 border-gray-300 text-center rounded-lg"
                      />
                    ))} */}
                    {loginOtp.map((digit, i) => (
                      <input
                        key={i}
                        ref={(el) => (loginOtpRefs.current[i] = el)}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(i, e.target.value, "login")}
                        onKeyDown={(e) => handleOtpKeyDown(i, e, "login")}
                        onPaste={(e) => handleOtpPaste(e, "login")}
                        className="w-12 h-12 border-2 border-gray-300 text-center rounded-lg"
                      />
                    ))}
                  </div>

                  <button
                    onClick={handleLogin2FA}
                    disabled={isLoading}
                    className="w-full bg-green-500 text-white py-3 rounded-lg"
                  >
                    {isLoading ? "Verifying..." : "Verify Code"}
                  </button>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default Login;